const styles = {
  container: {
    mb: 0,
  },
};

export default styles;
